import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Button, Input } from 'antd'
import classNames from 'classnames'

import { poppins } from '@/components/common/fonts'
import { NoCreditCard } from '@/components/tools/common/components/NoCreditCard'

import {
  Area,
  AreaSection,
  // AreaSectionSubTitle,
  AreaSectionTitle,
} from './styles'

type TopicAreaProps = {
  topic?: string
  onChangeTopic?: (topic: string) => void
  disabledChangeTopic?: boolean

  onGenerate?: () => void
  disabledGenerate?: boolean

  isError?: boolean

  /**
   * 유저 정보를 가져오는 중인지 여부
   */
  isLoadingUserInfo?: boolean
  /**
   * 로그인 여부
   */
  isLoggedIn?: boolean
  /**
   * 유료 사용자인지 여부
   */
  isPaidUser?: boolean
  /**
   * 남은 무료 제공 횟수
   */
  remainingFreeTrialCount?: number

  className?: string
}

export const TopicArea: FC<TopicAreaProps> = ({
  topic,
  onChangeTopic,

  disabledChangeTopic,
  onGenerate,
  disabledGenerate,

  isError,

  isLoadingUserInfo,
  isLoggedIn,
  isPaidUser,
  remainingFreeTrialCount = 0,

  className,
}) => {
  const { t } = useTranslation('common')

  /**
   * 이미지 제너레이터에서는 샘플 토픽 제공하지 않음
   */
  // const TOPICS = useMemo(
  //   () => [
  //     t('Dawn unveils a picturesque natural landscape, featuring waterfalls'),
  //     t('Muted colors envelop a young boy lost in the depths of a jungle'),
  //     t('Pastel hues create a magical garden with bees and blooming flowers'),
  //   ],
  //   [t],
  // )

  return (
    <TopicAreaContainer className={className}>
      {/* 
        토픽 입력 및 제출 버튼
      */}
      <AreaSection
        css={{
          marginBottom: '11px',
        }}
      >
        <AreaSectionTitle>{t('Generate Images')}</AreaSectionTitle>
        <TopicTextArea
          autoSize={{ minRows: 2, maxRows: 3 }}
          placeholder={t(
            'Example: Golden retriever wearing a scarf in a field of snow.',
          )}
          className={classNames({
            error: isError,
          })}
          value={topic}
          onChange={(e) => onChangeTopic?.(e.target.value)}
          disabled={disabledChangeTopic}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
              e.preventDefault()
              onGenerate?.()
            }
          }}
        />

        <GenerateButtonArea>
          <NoCreditCard
            isLoadingUserInfo={isLoadingUserInfo}
            isLoggedIn={isLoggedIn}
            isPaidUser={isPaidUser}
            remainingFreeTrialCount={remainingFreeTrialCount}
          />

          <GenerateButton
            size="large"
            type="primary"
            onClick={onGenerate}
            disabled={disabledGenerate}
          >
            {t('Generate')}
          </GenerateButton>
        </GenerateButtonArea>
      </AreaSection>

      {/* 
        이미지 제너레이터에서는 샘플 토픽을 제공하지 않음
      */}
      {/* 
        샘플 문구
      */}
      {/* <AreaSection>
        <AreaSectionSubTitle>
          {t('Need inspiration? Give these a try')}
        </AreaSectionSubTitle>

        <TopicSamples>
          {TOPICS.map((_topic) => (
            <TopicSample
              key={_topic}
              title={_topic}
              className={classNames({
                selected: topic === _topic,
              })}
              onClick={() => onChangeTopic?.(_topic)}
              disabled={disabledChangeTopic}
            >
              {_topic}
            </TopicSample>
          ))}
        </TopicSamples>
      </AreaSection> */}
    </TopicAreaContainer>
  )
}

const TopicAreaContainer = styled(Area)`
  grid-column: 1;
  grid-row: 1;

  /* border-bottom: 1px solid #f3f3f3; */
`

/**
 * - &.error - 에러 발생 시
 */
const TopicTextArea = styled(Input.TextArea)`
  padding: 10px 16px;
  margin-bottom: 13px;

  font-family: 'Noto Sans CJK';
  font-size: 14px;
  line-height: 19.6px;
  color: #000000;

  &::placeholder {
    color: #c6c6c6;
  }

  &.error {
    color: #ff0000;
  }
`

const GenerateButtonArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`

const GenerateButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 10px 26.5px;
  height: 40px;

  font-family: ${poppins.string};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
`

// const TopicSamples = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
//   align-items: start;
// `

/**
 * - &.selected: 선택된 경우
 */
// const TopicSample = styled(Button)`
//   border-radius: 9999px;
//   max-width: 100%;

//   font-family: ${poppins.string};
//   font-size: 10px;
//   line-height: 15px;
//   color: #222222;

//   text-overflow: ellipsis;
//   overflow: hidden;
//   white-space: nowrap;

//   span {
//     display: inline;
//   }

//   &.selected {
//     color: #3075f6;
//     border-color: #3075f6;
//   }
// `
